import { EnumObjectValue, enumObject } from '@app/base';
import { UserLookup } from './usersTypes';
import { AddressFragment } from './graphql';

export interface VRowMeta {
  createdAt: string;
  createdBy: UserLookup;
  organizationId: string;
}

export interface VRowData {
  title: string | null;
  note: string | null;
  tags: string | null;
}

export type Address = AddressFragment;

export const Locale = enumObject('Locale', ['uk', 'us_EST'] as const);

export type Locale = EnumObjectValue<typeof Locale>;

export const APPLICATION_MODULE_VALUES = ['Scheduling'] as const;
export const ApplicationModule = enumObject('ApplicationModule', APPLICATION_MODULE_VALUES);
export type ApplicationModule = EnumObjectValue<typeof ApplicationModule>;

export interface Optional<T> {
  value: T;
}
